import React, { useContext, useState } from "react";
import { makeStyles } from '@mui/styles';
import { ConversationContext } from "./index";
import SendButton from "../../images/chatbot/Sendbutton.svg";
import Reset from "../../images/chatbot/Reset.svg";
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';

const useStyles = makeStyles(theme => ({
  footerWrapper: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    position: "absolute",
    bottom: 0,
    left: 0,
    paddingBottom: theme.spacing(2.5),
    paddingTop: theme.spacing(1),
    background: "white"
  },
  footer: {
    display: "flex",
    width: "100%",
    height: 48,
    maxWidth: 890,
    padding: theme.spacing(0, 2),
    [theme.breakpoints.down("xs")]: {
      height: 40
    }
  },
  inputContainer: {
    position: "relative",
    width: "100%",
    marginRight: theme.spacing(1)
  },
  input: {
    width: "100%",
    padding: theme.spacing(1.75, 7, 1.75, 2),
    lineHeight: theme.typography.pxToRem(18),
    fontSize: theme.typography.pxToRem(16),
    outline: "none",
    border: "1px solid #BBBBBB",
    position: "relative",
    borderRadius: theme.typography.pxToRem(6),
    [theme.breakpoints.down("xs")]: {
      paddingTop: theme.spacing(1.25),
      paddingBottom: theme.spacing(1.25)
    }
  },
  sendMessageButton: {
    background: "transparent",
    position: "absolute",
    top: 0,
    right: 0,
    bottom: 0,
    cursor: "pointer",
    border: 0,
    outline: "none",
    display: "flex",
    borderRadius: theme.spacing(2),
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "center",
    "& img": {
      height: 20
    }
  },
  restartConversationButton: {
    border: "1px solid #BBBBBB",
    borderRadius: theme.spacing(1),
    width: 48,
    [theme.breakpoints.down("xs")]: {
      width: 40
    }
  },
  restartConversationButtonDisabled: {
    backgroundColor: "#EBEBE4 !important"
  },
  restartConversationImg: {
    width: 24,
    height: 24
  }
}));

function Footer({ placeholder, inputDisabled }) {
  const [userMessage, setUserMessage] = useState("");
  const { chatbotHandler, setInputPlaceholderText } = useContext(ConversationContext);

  const handleUserSubmit = e => {
    e.preventDefault();
    setInputPlaceholderText();
    let trimmedUserMessage = userMessage.trim();
    if (trimmedUserMessage) {
      chatbotHandler.sendMessage(trimmedUserMessage);
    }
    setUserMessage("");
  };

  const handleRestartConversation = () => {
    chatbotHandler.sendPostback(
      chatbotHandler.restartConversationIntentId,
      "Restart Conversation"
    );
  };

  const handleChange = e => {
    setUserMessage(e.target.value);
    chatbotHandler.sendTyping();
  };

  const classes = useStyles();
  return (
    <form onSubmit={handleUserSubmit}>
      <div className={classes.footerWrapper}>
        <div className={classes.footer}>
          <div className={classes.inputContainer}>
            <input
              className={classes.input}
              value={userMessage}
              onChange={handleChange}
              placeholder={placeholder}
              disabled={inputDisabled}
            />
            <Button className={classes.sendMessageButton} type="submit">
              <img src={SendButton} alt="Send" />
            </Button>
          </div>
          <IconButton
            className={classes.restartConversationButton}
            classes={{ disabled: classes.restartConversationButtonDisabled }}
            onClick={handleRestartConversation}
            disabled={inputDisabled || !!chatbotHandler.liveChatHandler}
          >
            <img className={classes.restartConversationImg} src={Reset} alt="Reset" />
          </IconButton>
        </div>
      </div>
    </form>
  );
}

export default Footer;
